import http from '@/utils/http';

export const getProductList = (
  params: Partial<API.Product.ProductListParams>,
) => http.get<API.Product.ProductListResult>('/product', { params });

export const createProduct = (data: Partial<API.Product.ProductItem>) =>
  http.post(`/product`, data);

export const updateProduct = ({
  id,
  ...rest
}: Partial<API.Product.ProductItem>) => http.patch(`/product/${id}`, rest);

export const deleteProduct = (id: number) => http.delete(`/product/${id}`);

export const getProduct = (id: number) =>
  http.get<API.Product.ProductItem>(`/product/${id}`);

export const updateProductShow = (id: number, isShow: 0 | 1) =>
  http.patch(`/product/${id}/show`, { isShow });

export const getCategoryList = () =>
  http.get<API.Product.Category[]>('/product/category');

export const updateCategorySort = (data: { ids: number[]; parentId: number }) =>
  http.patch(`/product/category/sort`, data);

export const createCategory = (data: Partial<API.Product.Category>) =>
  http.post(`/product/category`, data);

export const updateCategory = ({
  id,
  ...rest
}: Partial<API.Product.Category>) =>
  http.patch(`/product/category/${id}`, rest);
